import { Col, Modal, ModalProps, Row } from 'react-bootstrap';
import { useQuery } from '@apollo/client';
import { EmojiFontInspectDataQuery, EmojiFontInspectDataQueryVariables } from '../../../../../../__gqltypes__';
import { EMOJI_FONT_INSPECT_DATA } from '../../../components/apolloQueries';
import { LoadingLogo } from '../../../../devtools/components/Modal';
import { ClipboardButton } from '../../../../curation/screens/SongSearch/components/ClipboardButton';

type Props = ModalProps;
type FontData = EmojiFontInspectDataQuery['app']['emojiFontInspectData'][0];

export default function EmojiFontDataModal({show, onHide}: Props): JSX.Element {

  const { data, loading} = useQuery<
    EmojiFontInspectDataQuery,
    EmojiFontInspectDataQueryVariables
  >(EMOJI_FONT_INSPECT_DATA, {fetchPolicy: 'no-cache', skip: !show});

  const emojiFontData = data ? data.app.emojiFontInspectData : [];
  const renderData = (fontData: FontData, type: string) => {
    const updated = fontData ? new Date(fontData.updated) : null;
    return (
      <>
          <Row>
            <Col xs={3}>{type}</Col>
          </Row>
          <Row>
            <Col xs={3}>Version in cache</Col>
            <Col xs={6}>{fontData?.versionInCache}</Col>
          </Row>
          <Row>
            <Col xs={3}>Version</Col>
            <Col xs={6}>{fontData?.version}</Col>
          </Row>
          <Row>
            <Col xs={3}>Updated</Col>
            <Col xs={6}>{updated?.toString()}</Col>
          </Row>
          <Row>
            <Col xs={3}>Url</Col>
            <Col xs="auto">{fontData?.url}</Col>
          </Row>
          <Row>
            <Col xs={6}>
              <ClipboardButton title="Copy URL" textToCopy={fontData?.url ?? ''}/>
            </Col>
          </Row>
        </>
    );
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Body>
        {loading ? (
          <LoadingLogo show={loading} />
        ) : (
        <>
          {renderData(emojiFontData[0], 'Regular')}
          <div
            style={{
              width: '90%',
              height: '2px',
              backgroundColor: 'black',
              margin: '20px auto',
            }}
          />
          {renderData(emojiFontData[1], 'Old Android')}
        </>
        )}
      </Modal.Body>
    </Modal>
  );
}